/**
 * @desc Yung-审批前事件
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<ObjectMap>;
export function request(body: defs.tms.ApprovalBeforeRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/approval/beforeEvent`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
